// extracted by extract-css-chunks-webpack-plugin
module.exports = {"login-layout":"_2KH02","loginLayout":"_2KH02"};